<template lang="pug">
.v-breadcrumbs.breadcrumbs
	ul.breadcrumbs__list(v-if="items && items.length")
		li(v-for="(item, i) in items" :key="i")
				a.breadcrumbs__item(v-if='item.link' :href="item.link")
					.breadcrumbs__link
						v-svg-icon.breadcrumbs__separator(icon="chevron-right-sm")
						span {{item.text}}
				span.breadcrumbs__link(v-else)
					v-svg-icon.breadcrumbs__separator(icon="chevron-right-sm")
					span {{item.text}}

</template>

<script>
	export default {
		data() {
			return {};
		},

		computed: {
			items() {
				const breadcrumbs = this.$store.getters['breadcrumbs/items']
				if(breadcrumbs.length < 2) {
					return null;
				} else {
					return breadcrumbs.slice(-4, -1);
				}
			},
		},

		methods: {

		},
	}
</script>